import { useContext } from 'react'
import { RoutePlanningThemeContext } from './context'

export const useRoutePlanningTheme = () => useContext(RoutePlanningThemeContext)
